@if (editAllowed) {
    <h2 mat-dialog-title style="text-align: center">Enter Password</h2>
    <div style="text-align: center">Please enter password below</div>
    <i style="text-align: center">Warning: Documents after this one will be updated</i>
} @else {
    <div style="padding: 10px">
        <h2 mat-dialog-title style="text-align: center; margin-bottom: 6px">Attention</h2>
        <div style="text-align: center; font-size: small; margin-bottom: 4px">Editing of document not allowed if the PIC acceptance of the flight was already performed.</div>
        <div style="text-align: center; font-size: small">Either undo the PIC acceptance or create the new flight before continuing.</div>
    </div>
}
<form [formGroup]="passwordFormGroup" style="text-align: center">
    @if (editAllowed) {
        <mat-form-field>
            <input matInput type="password" placeholder="Password" formControlName="password" />
            @if (passwordFormGroup.controls["password"].hasError("required")) {
                <mat-error>
                    {{ "GENERAL.required" | translate }}
                </mat-error>
            }
            @if (passwordFormGroup.controls["password"].hasError("invalid")) {
                <mat-error>
                    {{ "PROFILE.UPDATE.wrongPasswordError" | translate }}
                </mat-error>
            }
        </mat-form-field>
    }
    @if (editAllowed) {
        <mat-dialog-actions style="justify-content: space-between" class="p-2">
            <button mat-raised-button color="warn" style="width: 100px" [mat-dialog-close]="false" cdkFocusInitial (click)="onCancel()">Cancel</button>
            <button mat-raised-button color="primary" style="width: 100px" type="submit" (click)="onConfirm()">Confirm</button>
        </mat-dialog-actions>
    } @else {
        <mat-dialog-actions style="justify-content: center" class="p-2">
            <button mat-raised-button color="warn" style="width: 100px" [mat-dialog-close]="false" cdkFocusInitial (click)="onCancel()">Ok</button>
        </mat-dialog-actions>
    }
</form>
